module.exports = __webpack_public_path__ + "static/media/DO.b240de12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/DO.svg
// module id = 2141
// module chunks = 7